const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

const transientOptionPrefix = "__new__:"

const isTransientOption = (value) => typeof value === "string" && value.startsWith(transientOptionPrefix)

export const mountBuildingContacts = () => {
  document.querySelectorAll(".building-contacts-card").forEach((root) => {
    if (root.dataset.buildingContactSearchBound === "true") return
    root.dataset.buildingContactSearchBound = "true"

    const searchInput = root.querySelector("[data-building-contact-search]")
    const rows = Array.from(root.querySelectorAll("[data-building-contact-row]"))
    const emptyState = root.querySelector("[data-building-contact-search-empty]")

    if (searchInput && rows.length > 0) {
      const applySearch = () => {
        const term = searchInput.value.trim().toLowerCase()
        let visibleCount = 0

        rows.forEach((row) => {
          const haystack = row.dataset.searchText || ""
          const matches = term.length === 0 || haystack.includes(term)
          row.hidden = !matches
          if (matches) visibleCount += 1
        })

        if (emptyState) emptyState.hidden = visibleCount > 0
      }

      searchInput.addEventListener("input", applySearch)
      applySearch()
    }
  })

  if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.select2) return

  document.querySelectorAll("[data-building-contact-picker]").forEach((select) => {
    if (select.dataset.buildingContactPickerBound === "true") return
    select.dataset.buildingContactPickerBound = "true"

    const root = select.closest(".building-contacts-card")
    const modal = root?.querySelector("[data-building-contact-modal]")
    const modalForm = modal?.querySelector("[data-building-contact-modal-form]")
    const modalFeedback = modal?.querySelector("[data-building-contact-modal-feedback]")
    const modalNameInput = modal?.querySelector("[data-building-contact-modal-name]")

    if (!root || !modal || !modalForm || !modalFeedback || !modalNameInput) return

    const $select = window.jQuery(select)
    const dropdownParent = $select.closest(".building-library-drawer")
    let pendingNewLabel = null

    const setModalFeedback = (message, tone = "error") => {
      if (!message) {
        modalFeedback.hidden = true
        modalFeedback.textContent = ""
        modalFeedback.removeAttribute("data-tone")
        return
      }

      modalFeedback.hidden = false
      modalFeedback.textContent = message
      modalFeedback.dataset.tone = tone
    }

    const removeTransientOptions = () => {
      Array.from(select.options).forEach((option) => {
        if (isTransientOption(option.value)) option.remove()
      })
    }

    const restorePreviousSelection = () => {
      removeTransientOptions()
      const previousValue = select.dataset.previousValue || ""
      $select.val(previousValue).trigger("change")
    }

    const closeModal = ({ restoreSelection = true } = {}) => {
      modal.hidden = true
      modal.setAttribute("aria-hidden", "true")
      document.body.style.overflow = ""
      setModalFeedback("")
      modalForm.reset()

      if (restoreSelection && pendingNewLabel !== null) restorePreviousSelection()

      pendingNewLabel = null
    }

    const openModal = (name) => {
      pendingNewLabel = name
      modalForm.reset()
      setModalFeedback("")
      modalNameInput.value = name
      modal.hidden = false
      modal.setAttribute("aria-hidden", "false")
      document.body.style.overflow = "hidden"
      window.setTimeout(() => modalNameInput.focus(), 0)
    }

    if ($select.hasClass("select2-hidden-accessible")) $select.select2("destroy")

    $select.select2({
      width: select.dataset.select2Width || "100%",
      allowClear: select.dataset.select2AllowClear === "true",
      placeholder: select.dataset.select2Placeholder || "Search contacts or type a new one",
      tags: true,
      dropdownParent: dropdownParent.length > 0 ? dropdownParent : undefined,
      createTag: (params) => {
        const term = params.term.trim()
        if (!term) return null

        const duplicate = Array.from(select.options).find((option) => {
          return option.text.trim().toLowerCase() === term.toLowerCase()
        })

        if (duplicate) return null

        return {
          id: `${transientOptionPrefix}${term}`,
          text: term,
          newTag: true
        }
      }
    })

    select.dataset.previousValue = select.value || ""

    $select.on("select2:select", (event) => {
      const data = event.params?.data
      if (!data) return

      if (data.newTag || isTransientOption(data.id)) {
        openModal(data.text)
        return
      }

      select.dataset.previousValue = data.id || ""
    })

    $select.on("select2:clear", () => {
      select.dataset.previousValue = ""
    })

    modal.querySelectorAll("[data-building-contact-modal-close]").forEach((button) => {
      button.addEventListener("click", () => closeModal())
    })

    document.addEventListener("keydown", (event) => {
      if (modal.hidden) return
      if (event.key !== "Escape") return
      closeModal()
    })

    modalForm.addEventListener("submit", async (event) => {
      event.preventDefault()

      const submitButton = modalForm.querySelector('button[type="submit"], input[type="submit"]')
      if (submitButton) submitButton.disabled = true
      setModalFeedback("")

      try {
        const response = await fetch(modalForm.action, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-CSRF-Token": csrfToken()
          },
          body: new FormData(modalForm),
          credentials: "same-origin"
        })

        const payload = await response.json()

        if (!response.ok) {
          const message = Array.isArray(payload.errors) ? payload.errors.join(", ") : "Could not create contact."
          setModalFeedback(message, "error")
          return
        }

        removeTransientOptions()
        const option = new Option(payload.label || payload.name, payload.id, true, true)
        select.add(option)
        $select.val(payload.id).trigger("change")
        select.dataset.previousValue = payload.id
        closeModal({ restoreSelection: false })
      } catch (_error) {
        setModalFeedback("Could not create contact right now. Please try again.", "error")
      } finally {
        if (submitButton) submitButton.disabled = false
      }
    })
  })
}
